import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const poolPondApi = createApi({
    reducerPath: "core/pool",
    baseQuery: axiosBaseQuery,
    tagTypes: ["poolList"],
    endpoints: (builder) => ({
        poolFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['poolList'],
            query: (query = '') => ({
                url: "/core/pool" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        poolCreate: builder.mutation({
            invalidatesTags: ['poolList'],
            query: (data) => ({
                url: `/core/pool`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        poolUpdate: builder.mutation({
            invalidatesTags: ['poolList'],
            // query: (data)=>({url: "/core/pool/"+data.id, method: "PUT", data})
            query: (data) => ({
                url: `/core/pool/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        poolDelete: builder.mutation({
            invalidatesTags: ['poolList'],
            query: (id) => ({ url: "/core/pool/" + id, method: "DELETE" })
        }),
    })
})

export const { usePoolFindAllQuery, usePoolCreateMutation, usePoolUpdateMutation, usePoolDeleteMutation } = poolPondApi;
export { poolPondApi };
